import { render, staticRenderFns } from "./eatself-carte.vue?vue&type=template&id=492e8db1"
import script from "./eatself-carte.vue?vue&type=script&lang=ts"
export * from "./eatself-carte.vue?vue&type=script&lang=ts"
import style0 from "./eatself-carte.vue?vue&type=style&index=0&id=492e8db1&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492e8db1')) {
      api.createRecord('492e8db1', component.options)
    } else {
      api.reload('492e8db1', component.options)
    }
    module.hot.accept("./eatself-carte.vue?vue&type=template&id=492e8db1", function () {
      api.rerender('492e8db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/eatself-carte.vue"
export default component.exports